class Hashing {
  static hashAny(array) {
    const json = JSON.stringify(array);
    return Hashing.hash(json);
  }
  // Taken from Java
  static hash(str) {
    let hash = 0;
    if (str.length === 0) {
      return hash;
    }
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash);
  }
}
export {
  Hashing
};
//# sourceMappingURL=Hashing.js.map
